import { Controller } from '@hotwired/stimulus';

import GridyCommon from '@/modules/gridy_common';
import ModuleLoader from '@/modules/module_loader';

export default class extends Controller {
  connect() {
    const options = ModuleLoader.getOptions();

    GridyCommon.gridy($('[data-gridy]'), { url: options.gridy?.url, ...this.gridyOptions() });
  }

  gridyOptions() {
    throw new Error('gridyOptions() must be implemented by the subclass');
  }
}
